import loginTranslation from './index.json';

export default loginTranslation;
